import { sendTrackingEvent } from '../services/service.tracking';
import { state as paramState } from '../store/store.page-params';

export const ICO_UNIFIED_DISPOSAL = 'ico-unified-disposal';

export const trackSimplifiedCertificateImpression = (offer: { isKelleyBuysYourCar: boolean; offerId: string }, showGetMyOfferScreen: boolean) => {
  let eventElement = offer.isKelleyBuysYourCar ? 'ico-kbyc-certificate-unified-disposal' : paramState?.category || 'ico-component';
  let eventResult = offer.isKelleyBuysYourCar ? 'ico-ud-010' : 'ico_thank';
  const { offerId } = offer;
  const firstEventFiredKey = `ico-ud-001-219F-${offerId}`;
  let eventData: { productName: string; ico: { offerId: string; firstEventFiredKey?: string } } = {
    productName: ICO_UNIFIED_DISPOSAL,
    ico: { offerId, firstEventFiredKey: firstEventFiredKey },
  };

  if (showGetMyOfferScreen) {
    eventElement = 'ico-certificate-my-account';
    eventResult = 'ico-ud-018';
  }

  sendTrackingEvent({
    event: 'analytics_event',
    eventName: 'ico-certificate-unified-disposal',
    eventElement,
    eventAction: 'impression',
    eventResult,
    eventData,
    eventNonInteractive: false,
  });
};

export const trackCertificateGetYourOffer = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-certificate-unified-disposal-button',
    eventAction: 'click',
    eventResult: 'ico-ud-002',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackCertificateRenewYourOffer = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-certificate-unified-disposal-button',
    eventAction: 'click',
    eventResult: 'ico-ud-003',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackCertificateViewYourOffer = (isKelleyBuysYourCar: boolean) => {
  const eventElement = isKelleyBuysYourCar ? 'ico-kbyc-certificate-unified-disposal-button' : 'ico-certificate-unified-disposal-button';
  const eventResult = isKelleyBuysYourCar ? 'ico-ud-011' : 'ico-ud-004';
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement,
    eventAction: 'click',
    eventResult,
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackIneligibleImpression = (ineligibleReasons: string) => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-ineligible-unified-disposal',
    eventAction: 'impression',
    eventResult: 'ico-ud-006',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
      ineligibleReasons: ineligibleReasons ? `ineligible::${ineligibleReasons}` : 'ineligible::not-available',
    },
    eventNonInteractive: false,
  });
};

export const trackOneStepAwayContinue = (isKelleyBuysYourCar: boolean = false, isInstantCashOffer: boolean = false) => {
  let eventElement: string, eventResult: string;
  if (isKelleyBuysYourCar && isInstantCashOffer) {
    eventElement = 'ico-one-step-combo-kbyc-unified-disposal-button';
    eventResult = 'ico-ud-020';
  } else if (isKelleyBuysYourCar) {
    eventElement = 'ico-one-step-kbyc-unified-disposal-button';
    eventResult = 'ico-ud-022';
  } else {
    // default to ICO
    eventElement = 'ico-one-step-unified-disposal-button';
    eventResult = 'ico-ud-007';
  }
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement,
    eventAction: 'click',
    eventResult,
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackOneStepAwayImpression = (isKelleyBuysYourCar: boolean = false, isInstantCashOffer: boolean = false) => {
  let eventElement: string, eventResult: string;
  if (isKelleyBuysYourCar && isInstantCashOffer) {
    eventElement = 'ico-one-step-combo-kbyc-unified-disposal';
    eventResult = 'ico-ud-021';
  } else if (isKelleyBuysYourCar) {
    eventElement = 'ico-one-step-kbyc-unified-disposal';
    eventResult = 'ico-ud-023';
  } else {
    // default to ICO
    eventElement = 'ico-one-step-unified-disposal';
    eventResult = 'ico-ud-008';
  }
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement,
    eventAction: 'impression',
    eventResult,
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackNotAvailableImpression = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-not-available-unified-disposal',
    eventAction: 'impression',
    eventResult: 'ico-ud-009',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackKelleyBuysYourCarOfferAcceptImpression = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-kbyc-offer-section',
    eventAction: 'impression',
    eventResult: 'ico-ud-012',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackKelleyBuysYourCarOfferAccept = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-kbyc-accept-offer-button',
    eventAction: 'click',
    eventResult: 'ico-ud-013',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackKelleyBuysYourCarModalImpression = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-kbyc-accept-offer-modal',
    eventAction: 'impression',
    eventResult: 'ico-ud-014',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackKelleyBuysYourCarModalCta = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-kbyc-accept-offer-modal-yes-button',
    eventAction: 'click',
    eventResult: 'ico-ud-015',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackKelleyBuysYourCarAcceptedModalImpression = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-kbyc-offer-accepted-modal',
    eventAction: 'impression',
    eventResult: 'ico-ud-016',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackKelleyBuysYourCarAcceptedImpression = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-kbyc-offer-accepted-section',
    eventAction: 'impression',
    eventResult: 'ico-ud-017',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};

export const trackCertificateGetYourOfferClick = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'ico-certificate-my-account-button',
    eventAction: 'click',
    eventResult: 'ico-ud-019',
    eventData: {
      productName: ICO_UNIFIED_DISPOSAL,
    },
    eventNonInteractive: false,
  });
};
